export const environment = {
  production: false,
  apiUrl: 'https://dev.api.directcall.remoteeye.com', //
  remoteeyeUrl: 'https://dev.core.remoteeye.com', //
  elmahKey: '8b99f31de9ac45caba59a5a58e54d7e2',
  elmahid: 'f9ac4331-fe65-48b5-b335-75f511cf4e7c',
  CallNotificationDurationSeconds: 50,
  tokenName: "skre45h",
  showGuestAskNameModal : true,
  tinyTokenLength : 10,
  firebaseConfig : {
    apiKey: "AIzaSyCpsBuPPiBGDP1aGU-vv0glh4YZRh0KZCk",
    authDomain: "helpdeskpushnotification.firebaseapp.com",
    projectId: "helpdeskpushnotification",
    storageBucket: "helpdeskpushnotification.firebasestorage.app",
    messagingSenderId: "467992460510",
    appId: "1:467992460510:web:d5d811a59643a1d8c8964f",
    measurementId: "G-JNS1LNH3V3",
    vapidKey: "BBDKhs7N7JDT0ZwV54bfLZ8Zr9qGJuZEckDHXxAlChTHj2DWXXQ9BY_9TEQ-agC4_cTpXN1v2dt9UBEp9wp5lk8"
  }
};
